import axios from "axios";
import config from "@config";
import { getCurrentLanguage } from "@storefront/core/i18n";
import { Logger } from "@storefront/core/lib/logger";
//import store from "@/store";

/**
 * load content blocks
 *
 * @returns array of content blocks
 */
export async function loadStoreLogo () {
  const lang = getCurrentLanguage();
  const storelang = config.languages[lang];
  const storeview = storelang["storeview"];
  const headers = {
    "Content-Type": "application/json",
    Store: storeview,
  };
  const query =
    "{storeConfig {id header_logo_src logo_alt base_media_url } }";
  const retval = await axios({
    url: config.shop.graphQLURL,
    method: "POST",
    headers: headers,
    data: { query: query },
  }).catch((e) => {
    Logger.error("loadStoreLogo ", "data-resolver cms", e)();
    throw e;
  });
  return retval.data.data.storeConfig;
}